import React, { useEffect, useRef, useState } from 'react'
import { Banner } from './fieldUi'
import ChatThread from './ChatThread'
import { useField } from './fieldContext'
import { metaOf, threadOf, unreadFor } from '../store'
import { useNarrow } from '../FieldOpsKit'

const QUICK_REP = [
    { text: 'A store asks for a better price on…', topic: 'price' }, { text: 'Customer complaint: ', topic: 'complaint' }, { text: 'I need a return pickup at…', topic: 'return' },
    { text: 'This store closed for good: ', topic: 'schedule' }, { text: 'I am running late, I will skip…', topic: 'schedule' }, { text: 'Can I change my route today? ', topic: 'schedule' },
]
const QUICK_DRIVER = [
    { text: 'I am running late, about 30 minutes.', topic: 'schedule' }, { text: 'Vehicle problem: ', topic: 'incident' }, { text: 'Customer refused the delivery: ', topic: 'complaint' },
    { text: 'Wrong or missing product on invoice ', topic: 'return' }, { text: 'Road closed / heavy traffic, I need to change the order.', topic: 'schedule' }, { text: 'Need help at the warehouse: ', topic: 'general' },
]

/**
 * Chat with the office (worker side). It never grows past the screen: on phones it is a full-height layer between the
 * portal menu and the tab bar; on wide screens it takes the height that is left under the tabs.
 */
export default function ChatScreen() {
    const f = useField()
    const { state, actor } = f
    const field = state.field
    const narrow = useNarrow(992)
    const messages = threadOf(field, actor.key)
    const meta = metaOf(field, actor.key)
    const unread = unreadFor(field, actor.key, 'worker')
    const wrapRef = useRef(null)
    const [h, setH] = useState(520)

    useEffect(() => { if (unread > 0) f.dispatch({ type: 'CHAT_READ', actorKey: actor.key, side: 'worker' }) }, [unread, messages.length]) // eslint-disable-line react-hooks/exhaustive-deps

    // phone: no page scroll behind the chat layer
    useEffect(() => {
        if (!narrow) return undefined
        const prev = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => { document.body.style.overflow = prev }
    }, [narrow])

    // wide: fit the rest of the viewport
    useEffect(() => {
        if (narrow) return undefined
        const fit = () => { if (wrapRef.current) setH(Math.max(380, window.innerHeight - wrapRef.current.getBoundingClientRect().top - 56)) }
        fit()
        const t = [setTimeout(fit, 200), setTimeout(fit, 900)]
        window.addEventListener('resize', fit)
        return () => { t.forEach(clearTimeout); window.removeEventListener('resize', fit) }
    }, [narrow])

    const thread = (
        <ChatThread messages={messages} side="worker" meta={meta} quick={actor.kind === 'rep' ? QUICK_REP : QUICK_DRIVER}
            onSend={(m) => f.send({ type: 'CHAT_SEND', actorKey: actor.key, from: 'worker', by: actor.name, text: m.text, topic: m.topic, ref: m.ref, photo: m.photo })} />
    )
    const offline = !field.online ? <Banner tone="warn">You are offline. Messages wait on this phone and are sent when you are back online.</Banner> : null

    if (narrow) return <div className="fo-chatfull">{offline}{thread}</div>
    return <div ref={wrapRef} style={{ height: h, display: 'flex', flexDirection: 'column' }}>{offline}{thread}</div>
}
